



















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import StepNumber from './elements/StepNumber.vue';
import StepDivider from './elements/StepDivider.vue';

@Component({
  components: {
    StepNumber,
    StepDivider,
  },
})
export default class Steps3 extends Vue {
  step = 1;

  @Prop({ type: Number, default: 1 }) private current!: number;

  setStep(step: number) {
    if (this.current > step) this.$emit('set-step', step);
  }
}
